import { lazy } from 'react';
/** Открывает форму отмены заказа */
export const CancelOrderFormPageAsync = lazy(() => import('./CancelOrderForm/CancelOrderFormPage'));